if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        // Magic Checkout reads the product form's `id` input.  On variant
        // products that input can be replaced during a section render, so
        // keep it in sync with the selected variant JSON as a safety net.
        this.productInfo = this.closest('product-info');
        this.syncVariantInput = this.syncVariantInput.bind(this);
        this.productInfo?.addEventListener('change', this.syncVariantInput);
        this.variantInputObserver = this.productInfo
          ? new MutationObserver(this.syncVariantInput)
          : null;
        this.variantInputObserver?.observe(this.productInfo, { childList: true, subtree: true });
        this.syncVariantInput();

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      disconnectedCallback() {
        this.productInfo?.removeEventListener('change', this.syncVariantInput);
        this.variantInputObserver?.disconnect();
      }

      syncVariantInput() {
        if (!this.productInfo || !this.variantIdInput) return;

        const variantNode = this.productInfo.querySelector('variant-selects [data-selected-variant]');
        if (!variantNode) {
          // Single-variant products do not render variant-selects. Preserve
          // the server-rendered button id instead of submitting an empty id.
          const fallbackVariantId =
            this.submitButton?.dataset.variantId || this.variantIdInput.dataset.variantId || '';
          if (fallbackVariantId) {
            this.variantIdInput.value = String(fallbackVariantId);
            this.variantIdInput.setAttribute('value', String(fallbackVariantId));
            this.variantIdInput.disabled = false;
          }
          return;
        }

        let variant;
        try {
          variant = JSON.parse(variantNode.textContent || '{}');
        } catch (error) {
          return;
        }

        const variantId = variant?.id ? String(variant.id) : '';
        if (this.variantIdInput.value !== variantId) {
          this.variantIdInput.value = variantId;
          this.variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (Object.prototype.hasOwnProperty.call(variant, 'available')) {
          this.variantIdInput.disabled = !variantId || variant.available === false;
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          
          // formData.append(
          //   'sections',
          //   this.cart.getSectionsToRender().map((section) => section.id)
          // );
          // formData.append('sections_url', window.location.pathname);
          // this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      if(window.reloadCart)
          {
            window.reloadCart();
            window.openCart();
          }
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                if(window.reloadCart)
          {
            window.reloadCart();
            window.openCart();
          }
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
